const { cardRank, cardSuit } = require("../../shared/game/belot/armenian/types");
const {
  MOLDOVAN_LAST_TRICK_BONUS,
  MOLDOVAN_CAPOT_POINTS,
  MOLDOVAN_TOTALS,
  TRUMP_POINTS_BY_RANK,
  PLAIN_POINTS_BY_RANK,
  MOLDOVAN_GAME_MODES,
} = require("./moldovanConstants");

function assertMode(mode) {
  if (!Object.values(MOLDOVAN_GAME_MODES).includes(mode)) {
    throw new Error(`moldovanScoring: unknown mode "${String(mode)}"`);
  }
}

function pointsForCard(card, mode, trumpSuit = null) {
  assertMode(mode);
  const rank = cardRank(card);
  if (mode === MOLDOVAN_GAME_MODES.allTrumps) return TRUMP_POINTS_BY_RANK[rank] ?? 0;
  if (mode === MOLDOVAN_GAME_MODES.noTrumps) return PLAIN_POINTS_BY_RANK[rank] ?? 0;
  const isTrump = trumpSuit != null && cardSuit(card) === trumpSuit;
  return isTrump ? (TRUMP_POINTS_BY_RANK[rank] ?? 0) : (PLAIN_POINTS_BY_RANK[rank] ?? 0);
}

function sumCardsPoints(cards, mode, trumpSuit = null) {
  return cards.reduce((sum, card) => sum + pointsForCard(card, mode, trumpSuit), 0);
}

function expectedRoundCardPointsNoLast(mode) {
  assertMode(mode);
  if (mode === MOLDOVAN_GAME_MODES.allTrumps) return MOLDOVAN_TOTALS.allTrumps - MOLDOVAN_LAST_TRICK_BONUS;
  if (mode === MOLDOVAN_GAME_MODES.noTrumps) return MOLDOVAN_TOTALS.noTrumps - MOLDOVAN_LAST_TRICK_BONUS;
  return MOLDOVAN_TOTALS.trump - MOLDOVAN_LAST_TRICK_BONUS;
}

function assertTotalsInvariant() {
  const byRankTrump = Object.values(TRUMP_POINTS_BY_RANK).reduce((a, b) => a + b, 0);
  const byRankPlain = Object.values(PLAIN_POINTS_BY_RANK).reduce((a, b) => a + b, 0);
  const allTrumpsNoLast = byRankTrump * 4;
  const noTrumpsNoLast = MOLDOVAN_TOTALS.noTrumps - MOLDOVAN_LAST_TRICK_BONUS;
  const mixedNoLast = byRankTrump + byRankPlain * 3;
  if (allTrumpsNoLast + MOLDOVAN_LAST_TRICK_BONUS !== MOLDOVAN_TOTALS.allTrumps) {
    throw new Error("moldovanScoring: all-trumps total invariant failed");
  }
  if (noTrumpsNoLast + MOLDOVAN_LAST_TRICK_BONUS !== MOLDOVAN_TOTALS.noTrumps) {
    throw new Error("moldovanScoring: no-trumps total invariant failed");
  }
  if (mixedNoLast + MOLDOVAN_LAST_TRICK_BONUS !== MOLDOVAN_TOTALS.trump) {
    throw new Error("moldovanScoring: trump total invariant failed");
  }
}

function resolveRoundScore({
  contractTeam,
  contractPoints,
  tricksByTeam,
  cardPointsByTeam,
  declarationPointsByTeam = [0, 0],
  lastTrickWinnerTeam,
  capotBid = false,
}) {
  const ct = Number(contractTeam);
  if (ct !== 0 && ct !== 1) throw new Error("moldovanScoring: contractTeam must be 0 or 1");
  const ot = ct === 0 ? 1 : 0;
  const trickPlusLast = [
    Number(cardPointsByTeam[0]) + (lastTrickWinnerTeam === 0 ? MOLDOVAN_LAST_TRICK_BONUS : 0),
    Number(cardPointsByTeam[1]) + (lastTrickWinnerTeam === 1 ? MOLDOVAN_LAST_TRICK_BONUS : 0),
  ];
  const contractSideTotal = trickPlusLast[ct] + Number(declarationPointsByTeam[ct] || 0);
  const target = capotBid ? MOLDOVAN_CAPOT_POINTS : Number(contractPoints);
  const success = capotBid ? Number(tricksByTeam[ct]) === 8 : contractSideTotal >= target;

  if (success) {
    return {
      bait: false,
      success: true,
      delta: [
        trickPlusLast[0] + Number(declarationPointsByTeam[0] || 0),
        trickPlusLast[1] + Number(declarationPointsByTeam[1] || 0),
      ],
      contractSideTotal,
    };
  }

  const defendersTotal =
    trickPlusLast[ot] +
    Number(declarationPointsByTeam[ot] || 0) +
    contractSideTotal;
  const delta = ct === 0 ? [0, defendersTotal] : [defendersTotal, 0];
  return { bait: true, success: false, delta, contractSideTotal };
}

module.exports = {
  pointsForCard,
  sumCardsPoints,
  expectedRoundCardPointsNoLast,
  assertTotalsInvariant,
  resolveRoundScore,
};
